import React from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { getText, GTPaymentMethodService } from 'apps/auth/services/GTPaymentMethodService';

import ActionBanner from './ActionBanner';

const PaymentMethodGaAccounts = (props) => {
    const { gotIt, methodMaxInfo, methodMinInfo, balanceNotEnough } = usePageMessages();
    const fromRestriction = props.commission?.restrictionFrom;
    const accountBalance = +props.item?.balance;

    const fromAmountIssue = GTPaymentMethodService.getIssueType(
        props.amountFrom,
        fromRestriction?.minAmount,
        fromRestriction?.maxAmount,
        fromRestriction?.multiple,
        accountBalance.toString(),
    );
    const popupText = getText(
        { name: props.item?.sourceName, amountFrom: props?.amountFrom },
        fromAmountIssue,
        fromRestriction,
        methodMaxInfo,
        methodMinInfo,
        balanceNotEnough,
        accountBalance,
    );

    const getBadge = (badge) => {
        if (badge) {
            return <Badge variant="primary" caption={badge} />;
        }
        return null;
    };
    const popupComponent = (
        <SimplePopup text={popupText} popupRef={props.popupRef}>
            <PopupButton title={gotIt} text={gotIt} iconName="check" onClick={() => props.popupRef.current?.close()} />
        </SimplePopup>
    );

    if (accountBalance > 0) {
        return (
            <Panel
                onClick={() => {
                    if (fromAmountIssue) {
                        props.popupRef.current?.open(popupComponent);
                    } else if (props.actionBanner && !fromAmountIssue) {
                        props.popupRef.current?.open(
                            <ActionBanner actionBanner={props.actionBanner} popupRef={props.popupRef} handleClick={() => props.onClick(props.item)} />,
                        );
                    } else {
                        props.onClick(props.item);
                    }
                }}
                negativeMargin
                isHoverable
            >
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <FlagIcon isDisabled={!!fromAmountIssue} name={toLowerCase(props.item?.currencyCode)} size="small" />
                    </DiskBadgeWrapper>
                    <PanelContent>
                        <Text color={fromAmountIssue ? 'lightGray' : 'primary'}>{`${props.item?.balance} ${props.item?.currencyCode}`}</Text>
                    </PanelContent>
                    <PanelRightBlock>{fromAmountIssue ? <Icon name="info-rounded" color="lightGray" size="16px" /> : getBadge(props.badge)}</PanelRightBlock>
                </PanelFrame>
            </Panel>
        );
    }
    return null;
};
export default PaymentMethodGaAccounts;
